import Singleton from '../Singleton'

class LayerManager extends Singleton {
    constructor () {
        super(LayerManager, function (instance) {
            instance._mapLayers = []
            instance._defaultBackground = null
        })
    }

    getLayers () {
        return this._mapLayers.map(layer => new layer)
    }

    register (newLayerClass) {
        const instance = new newLayerClass
        if (this.hasLayer(instance.name)) return
        this._mapLayers.push(newLayerClass)
    }

    hasLayer (layerName) {
        return this._mapLayers.find(layer => layer.name === layerName)
    }

    getDefault () {
        let defaultLayer = null
        if (this._defaultBackground) {
            defaultLayer = this._mapLayers.find(layer => layer.name === this._defaultBackground)
        } else {
            defaultLayer = this._mapLayers[0]
        }
        if (!defaultLayer) throw Error(`Unable to initialize the default layer`)
        return new defaultLayer
    }

    setDefault (layer) {
        if (typeof layer === 'string') {
            if (!this.hasLayer(layer)) throw Error(`Can not set uknownlayer [${layer}] as default`)
            this._defaultBackground = layer
        } else {
            if (!layer.name) throw Error('Layer has no name and can not be set as default')
            this.register(layer)
            this._defaultBackground = layer.name
        }
    }
}

export default new LayerManager()
